import { Route, Routes } from 'react-router-dom';
import Authentication from './pages/authentication/authentication.page';
import CGV from './pages/CGV/CGV.page';
import Checkout from './pages/checkout/checkout.page';
import Contact from './pages/contact/contact.page';
import Delivery from './pages/delivery/delivery.page';
import DeliveryInfos from './pages/delivery-infos/delivery-infos-page';
import Home from './pages/home/home.page';
import LegalesInfos from './pages/legales-infos/legales-infos.page';
import NotFound from './pages/not-found/not-found.page';
import Shop from './pages/shop/shop.page';

const Router = () => {
  return (
    <div>
      <Routes>
        <Route index element={<Home />} />
        <Route path="shop/*" element={<Shop />} />
        <Route path="auth" element={<Authentication />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="contact" element={<Contact />} />
        <Route path="delivery" element={<Delivery />} />
        <Route path="mentions-legales" element={<LegalesInfos />} />
        <Route path="CGV" element={<CGV />} />
        <Route path="delivery-infos" element={<DeliveryInfos />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default Router;
